module.exports = __webpack_public_path__ + "img/plan_map.765634db.svg";